import { PeoplePickerDialogProps } from './components/PeoplePickerDialog';
import './mutators/storeMutators';
import { LazyModule, createLazyComponent } from 'owa-bundling';

import { ComponentClass } from 'react';

export { PeoplePickerDialogProps };
export { ComponentClass };
export { default as PeoplePickerDialog } from './components/PeoplePickerDialog';

const lazyModule = new LazyModule(() =>
    import(/*webpackChunkName: "PeoplePickerDialog", webpackPrefetch: true */ './lazyIndex')
);
export let LazyPeoplePickerDialog = createLazyComponent(lazyModule, m => m.PeoplePickerDialog);
